import { Button, CircularProgress } from "@mui/material";
import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { FileApi } from "../../api/file-management";
import { configState } from "../../recoil/atoms";
import useAuthorization from "../../pages/Authentication/permissions/Authorization";
import { toast } from "react-toastify";

export default function ViewFile(props: any) {
  const { label, value } = props;
  const config = useRecoilValue(configState);
  const [url, setURL] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [download, setDownload] = useState<boolean>(false);
  const { canGetFile } = useAuthorization();

  const getFile = (uuid: string) => {
    const files = new FileApi(config);
    files
      .getFile(uuid!, config!.apiKey!.toString())
      .then((res) => {
        setURL(res.config.url!);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
        setIsLoading(false);
      });
  };

  const handleDownload = () => {
    setDownload(true);
    setIsLoading(true);
    getFile(value);
  };

  return (
    <>
      {canGetFile && !download ? (
        <Button variant="text" onClick={() => handleDownload()}>
          Download
        </Button>
      ) : isLoading ? (
        <CircularProgress
          color="secondary"
          size={14}
          sx={{
            ml: { xs: 0, xl: 3 },
            mt: 2,
          }}
        />
      ) : (
        <a href={url} target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
          View {label}
        </a>
      )}
    </>
  );
}
